import Vue from 'vue'
import Vuex from 'vuex'

Vue.use( Vuex )


// modules
import {auth} from './auth.module'
import {gender} from './gender.module'
import {nationality} from './nationality.module'
import {region} from './region.module'
import {maritalStatus} from './maritalStatus.module'
import {employee} from "./employee.module"
import {passportType} from "./passportType.module"
import {passportSeria} from './passportSeria.module'
import {ennounsment} from './announsment/announsment.module'
import { department } from './department/department.module'
import { vacancy } from './vacancy.module'
import {testcrud} from './testcrud.module'

import { title } from './reference/title.module'
export default new Vuex.Store( {
    modules: {
        testcrud,
        vacancy,
        employee,
        auth,
        passportSeria,
        gender,
        nationality,
        maritalStatus,
        region,
        passportType,
        ennounsment,
        department,
        title,

    },
    state: {
        jobs: {},
        details: {}
    },
    mutations: {
        ADD_JOB(state, payload) {
            state.jobs = payload.list
        },

    },
    actions: {
        addJobs({commit}, job) {
            commit( "ADD_JOB", job )
        },
    }
} )
